/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreatePerDiemPolicyRequest,
  DuplicatePerDiemPolicyRequest,
  PerDiemPolicyCountryListResponse,
  PerDiemPolicyDto,
  PerDiemPolicyListRequest,
  PerDiemPolicyListResponse,
  PerDiemPolicyRateListRequest,
  PerDiemPolicyRateListResponse,
  PerDiemPolicyRatesPreviewResponse,
  PerDiemPolicySlimDto,
  UpdatePerDiemPolicyRequest,
  UploadPerDiemPolicyCustomRatesPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PerDiemPolicyController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name CreatePerDiemPolicy
   * @request POST:/api/v1/per-diem-policies
   */
  createPerDiemPolicy = (data: CreatePerDiemPolicyRequest, params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyDto, any>({
      path: `/v1/per-diem-policies`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPerDiemPolicyPath = '/v1/per-diem-policies'
  static createPerDiemPolicyMethod = 'POST'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetPerDiemPolicyRates
   * @request POST:/api/v1/per-diem-policies/{policyId}/rates/list
   */
  getPerDiemPolicyRates = (
    policyId: string,
    data: PerDiemPolicyRateListRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PerDiemPolicyRateListResponse, any>({
      path: `/v1/per-diem-policies/${policyId}/rates/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPerDiemPolicyRatesPath = '/v1/per-diem-policies/${policyId}/rates/list'
  static getPerDiemPolicyRatesMethod = 'POST'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name UploadPerDiemPolicyCustomRates
   * @request POST:/api/v1/per-diem-policies/rates/custom/{countryIsoCode}
   */
  uploadPerDiemPolicyCustomRates = (
    countryIsoCode: string,
    data: UploadPerDiemPolicyCustomRatesPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<PerDiemPolicyRatesPreviewResponse, any>({
      path: `/v1/per-diem-policies/rates/custom/${countryIsoCode}`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadPerDiemPolicyCustomRatesPath = '/v1/per-diem-policies/rates/custom/${countryIsoCode}'
  static uploadPerDiemPolicyCustomRatesMethod = 'POST'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetAllPerDiemPolicies
   * @request POST:/api/v1/per-diem-policies/list
   */
  getAllPerDiemPolicies = (data: PerDiemPolicyListRequest, params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyListResponse, any>({
      path: `/v1/per-diem-policies/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllPerDiemPoliciesPath = '/v1/per-diem-policies/list'
  static getAllPerDiemPoliciesMethod = 'POST'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name DuplicatePerDiemPolicy
   * @request POST:/api/v1/per-diem-policies/duplicate
   */
  duplicatePerDiemPolicy = (data: DuplicatePerDiemPolicyRequest, params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyDto, any>({
      path: `/v1/per-diem-policies/duplicate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static duplicatePerDiemPolicyPath = '/v1/per-diem-policies/duplicate'
  static duplicatePerDiemPolicyMethod = 'POST'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetPerDiemPolicyById
   * @request GET:/api/v1/per-diem-policies/{policyId}
   */
  getPerDiemPolicyById = (policyId: string, params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyDto, any>({
      path: `/v1/per-diem-policies/${policyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPerDiemPolicyByIdPath = '/v1/per-diem-policies/${policyId}'
  static getPerDiemPolicyByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name DeletePerDiemPolicy
   * @request DELETE:/api/v1/per-diem-policies/{policyId}
   */
  deletePerDiemPolicy = (policyId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/per-diem-policies/${policyId}`,
      method: 'DELETE',
      ...params,
    })

  static deletePerDiemPolicyPath = '/v1/per-diem-policies/${policyId}'
  static deletePerDiemPolicyMethod = 'DELETE'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name UpdatePerDiemPolicy
   * @request PATCH:/api/v1/per-diem-policies/{policyId}
   */
  updatePerDiemPolicy = (
    policyId: string,
    data: UpdatePerDiemPolicyRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PerDiemPolicyDto, any>({
      path: `/v1/per-diem-policies/${policyId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePerDiemPolicyPath = '/v1/per-diem-policies/${policyId}'
  static updatePerDiemPolicyMethod = 'PATCH'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetPerDiemPolicyRatesCsvTemplateAsAttachment
   * @request GET:/api/v1/per-diem-policies/{policyId}/rates/template
   */
  getPerDiemPolicyRatesCsvTemplateAsAttachment = (policyId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/per-diem-policies/${policyId}/rates/template`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPerDiemPolicyRatesCsvTemplateAsAttachmentPath =
    '/v1/per-diem-policies/${policyId}/rates/template'
  static getPerDiemPolicyRatesCsvTemplateAsAttachmentMethod = 'GET'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetLegalPerDiemPolicyRatesCsvTemplateAsAttachment
   * @request GET:/api/v1/per-diem-policies/rates/template/{countryIsoCode}
   */
  getLegalPerDiemPolicyRatesCsvTemplateAsAttachment = (
    countryIsoCode:
      | 'UNDEFINED'
      | 'AC'
      | 'AD'
      | 'AE'
      | 'AF'
      | 'AG'
      | 'AI'
      | 'AL'
      | 'AM'
      | 'AN'
      | 'AO'
      | 'AQ'
      | 'AR'
      | 'AS'
      | 'AT'
      | 'AU'
      | 'AW'
      | 'AX'
      | 'AZ'
      | 'BA'
      | 'BB'
      | 'BD'
      | 'BE'
      | 'BF'
      | 'BG'
      | 'BH'
      | 'BI'
      | 'BJ'
      | 'BL'
      | 'BM'
      | 'BN'
      | 'BO'
      | 'BQ'
      | 'BR'
      | 'BS'
      | 'BT'
      | 'BU'
      | 'BV'
      | 'BW'
      | 'BY'
      | 'BZ'
      | 'CA'
      | 'CC'
      | 'CD'
      | 'CF'
      | 'CG'
      | 'CH'
      | 'CI'
      | 'CK'
      | 'CL'
      | 'CM'
      | 'CN'
      | 'CO'
      | 'CP'
      | 'CR'
      | 'CS'
      | 'CU'
      | 'CV'
      | 'CW'
      | 'CX'
      | 'CY'
      | 'CZ'
      | 'DE'
      | 'DG'
      | 'DJ'
      | 'DK'
      | 'DM'
      | 'DO'
      | 'DZ'
      | 'EA'
      | 'EC'
      | 'EE'
      | 'EG'
      | 'EH'
      | 'ER'
      | 'ES'
      | 'ET'
      | 'EU'
      | 'EZ'
      | 'FI'
      | 'FJ'
      | 'FK'
      | 'FM'
      | 'FO'
      | 'FR'
      | 'FX'
      | 'GA'
      | 'GB'
      | 'GD'
      | 'GE'
      | 'GF'
      | 'GG'
      | 'GH'
      | 'GI'
      | 'GL'
      | 'GM'
      | 'GN'
      | 'GP'
      | 'GQ'
      | 'GR'
      | 'GS'
      | 'GT'
      | 'GU'
      | 'GW'
      | 'GY'
      | 'HK'
      | 'HM'
      | 'HN'
      | 'HR'
      | 'HT'
      | 'HU'
      | 'IC'
      | 'ID'
      | 'IE'
      | 'IL'
      | 'IM'
      | 'IN'
      | 'IO'
      | 'IQ'
      | 'IR'
      | 'IS'
      | 'IT'
      | 'JE'
      | 'JM'
      | 'JO'
      | 'JP'
      | 'KE'
      | 'KG'
      | 'KH'
      | 'KI'
      | 'KM'
      | 'KN'
      | 'KP'
      | 'KR'
      | 'KW'
      | 'KY'
      | 'KZ'
      | 'LA'
      | 'LB'
      | 'LC'
      | 'LI'
      | 'LK'
      | 'LR'
      | 'LS'
      | 'LT'
      | 'LU'
      | 'LV'
      | 'LY'
      | 'MA'
      | 'MC'
      | 'MD'
      | 'ME'
      | 'MF'
      | 'MG'
      | 'MH'
      | 'MK'
      | 'ML'
      | 'MM'
      | 'MN'
      | 'MO'
      | 'MP'
      | 'MQ'
      | 'MR'
      | 'MS'
      | 'MT'
      | 'MU'
      | 'MV'
      | 'MW'
      | 'MX'
      | 'MY'
      | 'MZ'
      | 'NA'
      | 'NC'
      | 'NE'
      | 'NF'
      | 'NG'
      | 'NI'
      | 'NL'
      | 'NO'
      | 'NP'
      | 'NR'
      | 'NT'
      | 'NU'
      | 'NZ'
      | 'OM'
      | 'PA'
      | 'PE'
      | 'PF'
      | 'PG'
      | 'PH'
      | 'PK'
      | 'PL'
      | 'PM'
      | 'PN'
      | 'PR'
      | 'PS'
      | 'PT'
      | 'PW'
      | 'PY'
      | 'QA'
      | 'RE'
      | 'RO'
      | 'RS'
      | 'RU'
      | 'RW'
      | 'SA'
      | 'SB'
      | 'SC'
      | 'SD'
      | 'SE'
      | 'SF'
      | 'SG'
      | 'SH'
      | 'SI'
      | 'SJ'
      | 'SK'
      | 'SL'
      | 'SM'
      | 'SN'
      | 'SO'
      | 'SR'
      | 'SS'
      | 'ST'
      | 'SU'
      | 'SV'
      | 'SX'
      | 'SY'
      | 'SZ'
      | 'TA'
      | 'TC'
      | 'TD'
      | 'TF'
      | 'TG'
      | 'TH'
      | 'TJ'
      | 'TK'
      | 'TL'
      | 'TM'
      | 'TN'
      | 'TO'
      | 'TP'
      | 'TR'
      | 'TT'
      | 'TV'
      | 'TW'
      | 'TZ'
      | 'UA'
      | 'UG'
      | 'UK'
      | 'UM'
      | 'US'
      | 'UY'
      | 'UZ'
      | 'VA'
      | 'VC'
      | 'VE'
      | 'VG'
      | 'VI'
      | 'VN'
      | 'VU'
      | 'WF'
      | 'WS'
      | 'XI'
      | 'XU'
      | 'XK'
      | 'YE'
      | 'YT'
      | 'YU'
      | 'ZA'
      | 'ZM'
      | 'ZR'
      | 'ZW',
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/per-diem-policies/rates/template/${countryIsoCode}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLegalPerDiemPolicyRatesCsvTemplateAsAttachmentPath =
    '/v1/per-diem-policies/rates/template/${countryIsoCode}'
  static getLegalPerDiemPolicyRatesCsvTemplateAsAttachmentMethod = 'GET'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetStatutoryPerDiemPolicyRates
   * @request GET:/api/v1/per-diem-policies/rates/statutory/{countryIsoCode}
   */
  getStatutoryPerDiemPolicyRates = (countryIsoCode: string, params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyRatesPreviewResponse, any>({
      path: `/v1/per-diem-policies/rates/statutory/${countryIsoCode}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStatutoryPerDiemPolicyRatesPath =
    '/v1/per-diem-policies/rates/statutory/${countryIsoCode}'
  static getStatutoryPerDiemPolicyRatesMethod = 'GET'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetAllPerDiemPoliciesSlim
   * @request GET:/api/v1/per-diem-policies/list/slim
   */
  getAllPerDiemPoliciesSlim = (params: RequestParams = {}) =>
    this.http.request<PerDiemPolicySlimDto[], any>({
      path: `/v1/per-diem-policies/list/slim`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllPerDiemPoliciesSlimPath = '/v1/per-diem-policies/list/slim'
  static getAllPerDiemPoliciesSlimMethod = 'GET'
  /**
   * No description
   *
   * @tags per-diem-policy-controller
   * @name GetEligibleCountriesForPerDiemPolicies
   * @request GET:/api/v1/per-diem-policies/eligible-countries
   */
  getEligibleCountriesForPerDiemPolicies = (params: RequestParams = {}) =>
    this.http.request<PerDiemPolicyCountryListResponse, any>({
      path: `/v1/per-diem-policies/eligible-countries`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getEligibleCountriesForPerDiemPoliciesPath = '/v1/per-diem-policies/eligible-countries'
  static getEligibleCountriesForPerDiemPoliciesMethod = 'GET'
}
